// Columnas de tabla estándar. Los ids coinciden con el catálogo del backend (features/envioMails/remesas.tabla.js).
// Generado con apis-node/scripts/columnas-front.mjs: si se añade una columna allí, se regenera aquí
// (el backend rechaza ids que no conozca).

export const COLUMNAS_REMESAS = [
  {
    id: 'IdRemesa',
    label: 'ID',
    width: 90,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Remesa',
  },
  {
    id: 'empresaId',
    label: 'Empresa',
    width: 120,
    sortable: true,
    filter: 'multi',
    group: 'General',
  },
  {
    id: 'Descripcion',
    label: 'Asunto',
    width: 320,
    sortable: true,
    filter: 'text',
    group: 'Remesa',
  },
  {
    id: 'FechaEmision',
    label: 'Fecha emisión',
    width: 140,
    sortable: true,
    filter: 'date',
    group: 'Remesa',
    hora: true,
  },
  {
    id: 'FechaEnvio',
    label: 'Fecha envío',
    width: 140,
    sortable: true,
    filter: 'date',
    group: 'Remesa',
    hora: true,
  },
  { id: 'Hora', label: 'Hora', width: 90, sortable: true, filter: 'text', group: 'Remesa' },
  { id: 'Usuario', label: 'Usuario', width: 200, sortable: true, filter: 'multi', group: 'Remesa' },
  { id: 'actions', label: 'Acciones', width: 72, fixed: true },
];

export const TABLA_REMESAS = 'remesas';
